import imgLogo from "../../Assets/Logo/Logo.svg";
import imgMobileLogo from "../../Assets/Logo/LogoMobile.svg";
export default function Logo() {
  return (
    <>
      <img src={imgLogo} alt="Caregence" className="hidden md:block" />
      <img src={imgMobileLogo} alt="Caregence" className="md:hidden" />
    </>
  );
}
